<div class="load-favorites">
  <div class="load-favorites__message">Gib deinen Merklisten Code ein um deine Merkliste anzuzeigen.</div>

  <div class="load-favorites__input-wrapper">
    <input type="text"
           #inputEl
           (keydown)="beforeInputChange($event, idx)"
           (keyup)="afterInputChange($event, idx)"
           (paste)="onPaste($event, idx)"
           *ngFor="let input of [].constructor(codeLength);
           index as idx">
  </div>

  <div class="load-favorites__confirm" (click)="submit()">
    <brt-button [title]="submitButtonLabel" [color]="'river'" [disabled]="!isConfirmEnabled || isLoading"></brt-button>
  </div>
</div>
